import styles from './Background.module.css';

const ITEMS = [
  // Large backpack — upper centre-right
  {
    src: '/background/Group 1573.png',
    className: styles.backpackLarge,
  },
  // Big pencil — upper left, tilted
  {
    src: '/background/Group 1576.png',
    className: styles.pencilBig,
  },
  // Triangle ruler — top right corner
  {
    src: '/background/Group 1577.png',
    className: styles.ruler,
  },
  // Document + lock — left side
  {
    src: '/background/Group 1578.png',
    className: styles.document,
  },
  // Small pencil — bottom left
  {
    src: '/background/Group 1579.png',
    className: styles.pencilSmall,
  },
  // Cropped backpack — bottom right corner
  {
    src: '/background/Group 1580.png',
    className: styles.backpackCrop,
  },
];

export default function Background({ children }) {
  return (
    <div className={styles.root}>
      {ITEMS.map((item) => (
        <img
          key={item.src}
          src={item.src}
          alt=""
          aria-hidden="true"
          className={`${styles.item} ${item.className}`}
          draggable={false}
        />
      ))}
      <div className={styles.content}>{children}</div>
    </div>
  );
}
